import { useForm } from "react-hook-form";
import Button from "./Reusable/Button";
import TextField from "./Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { vehicleValidationForm } from "../utils/validationSchemas";
import { responsiveClassName } from "../utils/classNames";

const VehicleForm = ({ handleAddVehicle, isVehicleLoading }: any) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm<any>({
    resolver: yupResolver(vehicleValidationForm),
  });
  return (
    <form
      onSubmit={handleSubmit((data: any) => handleAddVehicle(data, setError))}
    >
      <div
        className={responsiveClassName(
          `grid  grid-cols-1 gap-x-4 mx-4`,
          "grid  grid-cols-2 gap-x-4 mx-4"
        )}
      >
        <TextField
          label={"Emergency Contact Number"}
          register={register("emergency_contact_number")}
          errors={errors?.emergency_contact_number}
        />
        <TextField
          label={"Vehicle Number"}
          register={register("license_number")}
          errors={errors?.license_number}
        />
        {/* <TextField
        label={"Insurance Date"}
        register={register("insurance_date")}
        errors={errors?.insurance_date}
      />
      <TextField
        label={"Permit Date"}
        register={register("permit_date")}
        errors={errors?.permit_date}
      /> */}
        <TextField
          label={"Insurance Comapny"}
          register={register("insurance_company")}
          errors={errors?.insurance_company}
        />
        <TextField
          label={"Insurance Company Contact Number"}
          register={register("insurance_company_contact_number")}
          errors={errors?.insurance_company_contact_number}
        />
        <TextField
          label={"Samiti Name"}
          register={register("samiti_name")}
          errors={errors?.samiti_name}
        />
        <TextField
          label={"Samiti Contact Number"}
          register={register("samiti_contact_number")}
          errors={errors?.samiti_contact_number}
        />
        <TextField
          label={"Chaises No."}
          register={register("chaises_no")}
          errors={errors?.chaises_no}
        />
      </div>
      <div className={tw`flex w-full justify-end`}>
        <div className={tw`w-32`}>
          <Button label={"Create"} isLoading={isVehicleLoading} />
        </div>
      </div>
    </form>
  );
};

export default VehicleForm;
